export default class MuteDocTitle {
  static start() {
    document.body.setAttribute('aria-hidden', 'true');
    return MuteDocTitle.stop;
  }

  static stop() {
    document.body.removeAttribute('aria-hidden');
  }
}
